import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@homeleite/arch';
import { AdminGuard } from '../../core/guards/admin.guard';
import { BreedersComponent } from './breeders.component';

const routes: Routes = [
    {
        path: 'breeders',
        component: BreedersComponent,
        canActivate: [AuthGuard, AdminGuard],
        data: { title: 'Home Leite - Reprodutores' }
    }
];

export const BreedersRoutes = RouterModule.forChild(routes);
